module.exports = __webpack_public_path__ + "static/media/dessert.48c8a1be.jpg";